import { Organisation } from '~organisations/domain';

import genericAdditionalFields from './additionalOutcomeCaptureFields/generic';
import logo from './images/logo.png';

const hcfConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {
    '1': genericAdditionalFields,
    '2': genericAdditionalFields,
  },
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default hcfConfig;
